import axios from '@app/config/axios.config';
import { getTablesParams } from '../apiType';
import { Mandat } from './mandats';
import { User } from './users';

export enum PotentielsParrainagesStatus {
    A_traiter = 'A_traiter',
    Ne_pas_appeler = 'Ne_pas_appeler',
    Refus = 'Refus',
    Rappeler = 'Rappeler',
    Sans_reponse = 'Sans_reponse',
    Doc_envoyee = 'Doc_envoyee',
    Parrainage = 'Parrainage',
    Archive = 'Archive',
}

export type PotentielsParrainages = {
    id: number;
    createdAt: string;
    updatedAt: string;
    status: PotentielsParrainagesStatus;
    raisonSociale: string;
    titre: string;
    prenom1: string;
    nom1: string;
    prenom2: string;
    nom2: string;
    adresse: string;
    cp: string;
    numeroPostal: string;
    localite: string;
    telephone1: string;
    telephone2: string;
    raisonSocialePj: string;
    libelleFacture: string;
    correspondance: string;
    accordDe: string;
    dateAccord: string;
    email: string;
    infosInternes: string;
    publicite: string;
    reconduction: boolean;
    annonceOk: boolean;
    ca: number;
    noClub: string;
    feuilletId?: string;
    validated: boolean;
    collaborateur: User;
    mandat: Mandat;
    POTENTIEL_MODIFIE: boolean;
    BDD_OK: boolean;
};

export const getPotentielsParrainages = async (
    params: getTablesParams
): Promise<{
    result: PotentielsParrainages[];
    totalCount: number;
    aggregate: any;
}> => {
    try {
        const res = await axios.get('/potentiels-parrainages', { params });
        return res.data;
    } catch (err) {
        console.error(err);
        return { result: [], totalCount: 0, aggregate: null };
    }
};

export const getPotentielsParrainagesById = async (id: string) => {
    return await axios.get(`/potentiels-parrainages/${id}`);
};

export interface CreatePotentielsParrainagesBody {
    status?: PotentielsParrainagesStatus;
    raisonSociale?: string;
    titre?: string;
    prenom1?: string;
    nom1?: string;
    prenom2?: string;
    nom2?: string;
    adresse?: string;
    cp?: string;
    numeroPostal?: string;
    localite?: string;
    telephone1?: string;
    telephone2?: string;
    raisonSocialePj?: string;
    libelleFacture?: string;
    correspondance?: string;
    accordDe?: string;
    dateAccord?: string;
    email?: string;
    infosInternes?: string;
    publicite?: string;
    reconduction?: boolean;
    annonceOk?: boolean;
    ca?: number;
    noClub?: string;
    feuilletId?: string;
    validated?: boolean;
    collaborateur?: string;
}

export const createPotentielsParrainages = async (
    body: CreatePotentielsParrainagesBody
) => {
    return await axios.post(`/potentiels-parrainages`, body);
};

export const updatePotentielsParrainages = async (
    id: string,
    body: CreatePotentielsParrainagesBody
) => {
    return await axios.patch(`/potentiels-parrainages/${id}`, body);
};

export const markAsProcessed = async (id: string) => {
    return await axios.post(`/potentiels-parrainages/${id}/process`);
};

export const archiveManyPotentielsParrainages = async (ids: number[]) => {
    return await axios.patch('/potentiels-parrainages/archive-many', { ids });
};

export const setToTreatManyPotentielsParrainages = async (ids: number[]) => {
    return await axios.patch('/potentiels-parrainages/set-to-treat-many', { ids });
};

export const assignManyPotentielsParrainages = async (
    ids: number[],
    collaborateurId: number
) => {
    return await axios.patch('/potentiels-parrainages/assign-many', {
        ids,
        collaborateurId,
    });
};
